import { FC } from "react";
import StandardModal from "./StandardModal";

interface StandardModalEmailUnicoProps {
  showModal: boolean;
  onCloseModal: () => void;
}

const StandardModalEmailUnico: FC<StandardModalEmailUnicoProps> = ({ showModal, onCloseModal }) => {
  return (
    <StandardModal
      showModal={showModal}
      scrollable={false}
      onCloseModal={onCloseModal}
      videoSrc="https://www.youtube.com/watch?v=RPUuT-CG-nA"
      topBar=" O que é o e-mail único da administradora?"
      titulo="O que é o e-mail único da administradora?"
      tituloStyle={{ fontSize: "1vw", fontWeight: "bold", color: "#2F4050", textAlign: "left" }}
      conteudoPrimario="Para facilitar o processo de captação de documentos, sua administradora agora conta com um e-mail único,
      gerado automaticamente pelo Group Condomínios.Esse e-mail é fixo, não pode ser alterado e tem como objetivo centralizar o redirecionamento
      das notas fiscais recebidas pela administradora de todos os condomínios."
      conteudoPrimarioStyle={{ marginBottom: "0.85vh", fontSize: "0.85vw" }}
      conteudoSecundario={
        <>
          <p style={{ fontSize: "1vw", color: "#2F4050", fontWeight: "bold" }}>Como funciona?</p>
          <p style={{ fontSize: "0.85vw", color: "#2F4050" }}>
            Você deverá redirecionar os e-mails da sua caixa de entrada atual para esse novo e-mail da Group. Assim,
            todas as notas fiscais serão recebidas e processadas corretamente pelo sistema. Veja no vídeo acima as
            formas de configurar na prática.
          </p>
        </>
      }
      size="lg"
      fecharModalAoClicarFora={true}
      containerStyle={{ margin: 0, paddingLeft: "1vw", textAlign: "left" }}
      footer={null}
    />
  );
};

export default StandardModalEmailUnico;
